import React from "react";
import FacebookFeedPreview from "./FacebookFeedPreview";
import FacebookStoryPreview from "./FacebookStoryPreview";
import MediaProductTypeDropdown from "./components/MediaProductTypeDropdown";
import usePostGenerator from "utils/hooks/usePostGenerator";
import MoreOptions from "./components/MoreOptions";
import { getNetworkValidationIndex } from "utils/hooks/usePostValidator";

const FacebookPreview = (props) => {

    const {
        postGroup, 
        
        isEditable,
        onDeleteNetworkPost,
        onCreateNetworkPost,
        onPreferencesEdit,
        allPosts,
        postIndex,
        isSimpleView // Add this line
    } = props;

    const network = "facebook";
    const {  generatePostWithNewMediaProductType } = usePostGenerator();

    const handleOnMediaProductTypeChange = (media_product_type) => {
        const postToCopy = allPosts?.[postIndex];
        const newPost = generatePostWithNewMediaProductType(postToCopy, network, media_product_type);
        !!onCreateNetworkPost && onCreateNetworkPost({...newPost}, true);
    }
    
    return (<>
        {!isSimpleView && isEditable && (
            <div className="flex items-stretch w-full">
                <MediaProductTypeDropdown 
                    post={props?.[0] || props}
                    isEditable={isEditable}
                    onChange={(media_product_type) => handleOnMediaProductTypeChange(media_product_type)}
                    allowedMediaProductTypes={["FEED", "STORY", "REEL"]}
                />
            </div>
        )}
        <FacebookFeedPreview {...props} />
        <FacebookStoryPreview {...props} />
    </>)
}

export default FacebookPreview;